import { useEffect, useState } from 'react';
import { shallowEqual } from 'react-redux';
import { setAnalyticsData, setAnalyticsPageName, Config } from '@vm/omega-shared-component-webapp';
import { AnalyticsDataType, ProductSummaryType } from '../../types/types';

export const useAdobeAnalytics = (location, productData: ProductSummaryType) => {
  const [dataLayerState, setDataLayer] = useState<object>();

  const currentPath = location?.pathname;
  const isMarketplacePage = currentPath === Config.get('paths.marketplace.root');
  const isProductPage = currentPath === Config.get('paths.marketplace.product');

  const globalPageNameBase = 'business marketplace';

  const bufferDataLayer = (dataLayer: Partial<AnalyticsDataType>) => {
    setAnalyticsPageName(dataLayer.globalPageName);
    const isEqual = shallowEqual(dataLayer, dataLayerState);
    if (!isEqual) {
      setDataLayer(dataLayer);
      setAnalyticsData(dataLayer);
    }
  };

  useEffect(() => {
    let dataLayer: Partial<AnalyticsDataType> = {
      pageName: location.pathname.toLowerCase(),
      globalPageName: globalPageNameBase,
      marketplaceError: false,
      productError: false,
    };

    if (isMarketplacePage || isProductPage) {
      const { productListError, productDataError, productListReady, productDataReady, productSummary } = productData;

      if (productSummary?.productId && productSummary?.nbaId) {
        dataLayer = {
          ...dataLayer,
          productId: productSummary.productId,
          nbaId: productSummary.nbaId,
        };
      }

      // Deal witth any data errors
      if (productListError || productDataError) {
        dataLayer = {
          ...dataLayer,
          marketplaceError: !!productListError,
          productError: !!productDataError,
          globalPageName: `${globalPageNameBase}|api-error`,
        };
        bufferDataLayer(dataLayer);
      } else if (productListReady) {
        // This is when the product data is available
        if (isProductPage && productSummary?.productTitle) {
          dataLayer.pageName = `${dataLayer.pageName}/${productSummary?.productTitle}`;
          dataLayer.globalPageName = `${globalPageNameBase}|${productSummary?.productTitle}`;
        }

        dataLayer = {
          ...dataLayer,
          productName: productSummary?.productTitle,
        };
        bufferDataLayer(dataLayer);
      } else if (productListReady || productDataReady) {
        bufferDataLayer(dataLayer);
      }
    } else {
      dataLayer = {
        ...dataLayer,
        pageName: '/page-not-found',
        globalPageName: `${globalPageNameBase}|page-not-found`,
        productId: productData?.productSummary.productId,
        nbaId: productData?.productSummary.nbaId,
      };
      bufferDataLayer(dataLayer);
    }
  }, [location, productData?.productListReady, productData?.productDataReady, productData?.productDataError]);
};
